export const DeepCopy = obj => JSON.parse(JSON.stringify(obj));
